export default "__VITE_ASSET__dJ$ULFcuzX43djbIEsCZPw__ 560w, __VITE_ASSET__epdbhdyBUyD3hvxx0_dcTg__ 1152w, __VITE_ASSET__ykb1zIozoJBMq4UvQnlhcQ__ 2304w";